import COUNTRIES from '../countries.translations'

import translations from './iron.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/iron'

export const iron: Metal = {
  id: 1,
  slug: 'iron',
  name: t.name,
  symbol: 'Fe',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Carajás mountains, iron mines (Brazil)',
      region: t.mine0Region,
      slug: 'carajas-mountains',
      coordinates: [-50.16, -6.06],
    },
    {
      name: 'Newman, iron mines (Australia)',
      region: t.mine1Region,
      slug: 'newman',
      coordinates: [119.73, -23.36],
    },
    {
      name: 'Tom Price, iron mines (Australia)',
      region: t.mine2Region,
      slug: 'tom-price',
      coordinates: [117.79, -22.69],
    },
    {
      name: 'Gubkin, iron mines (Russia)',
      region: t.mine3Region,
      slug: 'gubkin',
      coordinates: [37.55, 51.28],
    },
  ],
  countries: [
    { name: COUNTRIES.australia, percent: 37.2 },
    { name: COUNTRIES.brazil, percent: 17.6 },
    { name: COUNTRIES.china, percent: 10.8 },
    { name: COUNTRIES.india, percent: 10.8 },
    { name: COUNTRIES.russia, percent: 3.6 },
    { name: COUNTRIES.iran, percent: 3.6 },
    { name: COUNTRIES.southAfrica, percent: 2.6 },
  ],
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 4, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
